module.exports = __webpack_public_path__ + "img/digitalCurrencies.1131724a.svg";